import * as t from "io-ts";

const V2DomainsC = t.union([
    t.literal("expertiseAndResources"),
    t.literal("purpose"),
    t.literal("relationships"),
    t.literal("teachingAndLearning"),
    t.literal("wellBeing"),
]);

const V2ExpertiseAndResourcesC = t.union([
    t.literal("qualifiedStaff"),
    t.literal("resourceConstraint"),
    t.literal("resourcePlanning"),
    t.literal("resources"),
    t.literal("responsivenessToSpecialNeeds"),
]);

const V2PurposeC = t.union([
    t.literal("godsStory"),
    t.literal("holisticTeaching"),
    t.literal("integratedWorldView"),
    t.literal("partnership"),
    t.literal("questioning"),
    t.literal("responsibility"),
    t.literal("spiritualFormation"),
]);

const V2RelationshipsC = t.union([
    t.literal("caringEnvironment"),
    t.literal("christlikeTeachers"),
    t.literal("communityEngagement"),
    t.literal("familyRelationships"),
    t.literal("insularCulture"),
    t.literal("leadershipInterdependence"),
    t.literal("mentoringStudents"),
    t.literal("prosocialOrientation"),
    t.literal("supportiveLeadership"),
]);

const V2TeachingAndLearningC = t.union([
    t.literal("behaviorsForLearning"),
    t.literal("bestPracticeOrientation"),
    t.literal("collaboration"),
    t.literal("cultureOfImprovement"),
    t.literal("dataDrivenImprovement"),
    t.literal("engagedLearning"),
    t.literal("feedback"),
    t.literal("individualizedInstruction"),
    t.literal("outcomesFocus"),
    t.literal("professionalDevelopment"),
    t.literal("systemsThinking"),
]);

const V2WellBeingC = t.union([t.literal("healthyLiving"), t.literal("resilience"), t.literal("stress")]);

const V2ConstructsC = t.union([
    t.literal("behaviorsForLearning"),
    t.literal("bestPracticeOrientation"),
    t.literal("caringEnvironment"),
    t.literal("christlikeTeachers"),
    t.literal("collaboration"),
    t.literal("communityEngagement"),
    t.literal("cultureOfImprovement"),
    t.literal("dataDrivenImprovement"),
    t.literal("engagedLearning"),
    t.literal("familyRelationships"),
    t.literal("feedback"),
    t.literal("godsStory"),
    t.literal("healthyLiving"),
    t.literal("holisticTeaching"),
    t.literal("individualizedInstruction"),
    t.literal("insularCulture"),
    t.literal("integratedWorldView"),
    t.literal("leadershipInterdependence"),
    t.literal("mentoringStudents"),
    t.literal("outcomesFocus"),
    t.literal("partnership"),
    t.literal("professionalDevelopment"),
    t.literal("prosocialOrientation"),
    t.literal("qualifiedStaff"),
    t.literal("questioning"),
    t.literal("resilience"),
    t.literal("resourceConstraint"),
    t.literal("resourcePlanning"),
    t.literal("resources"),
    t.literal("responsibility"),
    t.literal("responsivenessToSpecialNeeds"),
    t.literal("spiritualFormation"),
    t.literal("stress"),
    t.literal("supportiveLeadership"),
    t.literal("systemsThinking"),
]);

const V2DomainConstructsC = t.type({
    domain: V2DomainsC,
    construct: V2ConstructsC,
});

const V2DataC = t.type({
    expertiseAndResources: t.type({
        qualifiedStaff: t.number,
        resourceConstraint: t.number,
        resourcePlanning: t.number,
        resources: t.number,
        responsivenessToSpecialNeeds: t.number,
    }),
    purpose: t.intersection([
        t.type({
            godsStory: t.number,
            holisticTeaching: t.number,
            integratedWorldView: t.number,
            partnership: t.number,
            responsibility: t.number,
            spiritualFormation: t.number,
        }),
        t.partial({
            questioning: t.number,
        }),
    ]),
    relationships: t.type({
        caringEnvironment: t.number,
        christlikeTeachers: t.number,
        communityEngagement: t.number,
        familyRelationships: t.number,
        insularCulture: t.number,
        leadershipInterdependence: t.number,
        mentoringStudents: t.number,
        prosocialOrientation: t.number,
        supportiveLeadership: t.number,
    }),
    teachingAndLearning: t.type({
        behaviorsForLearning: t.number,
        bestPracticeOrientation: t.number,
        collaboration: t.number,
        cultureOfImprovement: t.number,
        dataDrivenImprovement: t.number,
        engagedLearning: t.number,
        feedback: t.number,
        individualizedInstruction: t.number,
        outcomesFocus: t.number,
        professionalDevelopment: t.number,
        systemsThinking: t.number,
    }),
    wellBeing: t.type({
        healthyLiving: t.number,
        resilience: t.number,
        stress: t.number,
    }),
});

const V2OpportunityC = t.intersection([
    t.type({
        title: t.string,
        prologue: t.string,
    }),
    t.partial({
        extra: t.string,
    }),
]);

const V2AreasOfImprovementC = t.type({
    expertiseAndResources: t.type({
        qualifiedStaff: V2OpportunityC,
        resourceConstraint: V2OpportunityC,
        resourcePlanning: V2OpportunityC,
        resources: V2OpportunityC,
        responsivenessToSpecialNeeds: V2OpportunityC,
    }),
    purpose: t.intersection([
        t.type({
            godsStory: V2OpportunityC,
            holisticTeaching: V2OpportunityC,
            integratedWorldView: V2OpportunityC,
            partnership: V2OpportunityC,
            responsibility: V2OpportunityC,
            spiritualFormation: V2OpportunityC,
        }),
        t.partial({
            questioning: V2OpportunityC,
        }),
    ]),
    relationships: t.type({
        caringEnvironment: V2OpportunityC,
        christlikeTeachers: V2OpportunityC,
        communityEngagement: V2OpportunityC,
        familyRelationships: V2OpportunityC,
        insularCulture: V2OpportunityC,
        leadershipInterdependence: V2OpportunityC,
        mentoringStudents: V2OpportunityC,
        prosocialOrientation: V2OpportunityC,
        supportiveLeadership: V2OpportunityC,
    }),
    teachingAndLearning: t.type({
        behaviorsForLearning: V2OpportunityC,
        bestPracticeOrientation: V2OpportunityC,
        collaboration: V2OpportunityC,
        cultureOfImprovement: V2OpportunityC,
        dataDrivenImprovement: V2OpportunityC,
        engagedLearning: V2OpportunityC,
        feedback: V2OpportunityC,
        individualizedInstruction: V2OpportunityC,
        outcomesFocus: V2OpportunityC,
        professionalDevelopment: V2OpportunityC,
        systemsThinking: V2OpportunityC,
    }),
    wellBeing: t.type({
        healthyLiving: V2OpportunityC,
        resilience: V2OpportunityC,
        stress: V2OpportunityC,
    }),
});

export const V2ReportC = t.type({
    id: t.string,
    results: t.intersection([
        t.type({
            benchmarks: V2DataC,
            keyGrowthOpportunities: t.array(V2DomainConstructsC),
            meaningfulStrengths: t.array(V2DomainConstructsC),
            raw: V2DataC,
        }),
        // How the two lists were chosen; absent on reports ranked before INC-26068.
        t.partial({ ranking: t.string }),
    ]),
    version: t.literal("2"),
    year: t.string,
    type: t.string,
    surveysCompleted: t.type({
        students: t.number,
        parents: t.number,
        supportStaff: t.number,
        teachers: t.number,
        boardMembers: t.number,
        administrators: t.number,
        alumni: t.number,
    }),
    constituentGroups: t.type({
        students: t.number,
        parents: t.number,
        supportStaff: t.number,
        teachers: t.number,
        boardMembers: t.number,
        administrators: t.number,
        alumni: t.number,
    }),
});

export type V2Domains = t.TypeOf<typeof V2DomainsC>;
export type V2ExpertiseAndResources = t.TypeOf<typeof V2ExpertiseAndResourcesC>;
export type V2Purpose = t.TypeOf<typeof V2PurposeC>;
export type V2Relationships = t.TypeOf<typeof V2RelationshipsC>;
export type V2TeachingAndLearning = t.TypeOf<typeof V2TeachingAndLearningC>;
export type V2WellBeing = t.TypeOf<typeof V2WellBeingC>;
export type V2AreasOfImprovement = t.TypeOf<typeof V2AreasOfImprovementC>;

export type V2Report = t.TypeOf<typeof V2ReportC>;
export type FSCIBrandedV2Report = { tag: "v2_FSCI"; value: V2Report };
